import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-active-minutes',
  templateUrl: './active-minutes.component.svg',
  styleUrls: [],
})
export class ActiveMinutesComponent extends MedrecordIcon {
  viewHeight: number = 24;
  viewWidth: number = 24;
}
